module.exports = __webpack_public_path__ + "media/tweet-to-video.ba72c51c.mp4";